module.exports = __webpack_public_path__ + "static/media/rightFaceArrow.6fedcc33.svg";